import { useContext, useEffect } from 'react';
import MapContext from '../../contexts/data/MapContext';
import type { CustomHomPageRegion } from '../../contexts/data/MapContext';

interface CustomHomePageLayersOptions {
    enabled: boolean;
    regions: CustomHomPageRegion[];
    selectedTitles?: string[];
}

const useCustomHomePageLayers = ({
    enabled,
    regions,
    selectedTitles
}: CustomHomePageLayersOptions) => {
    const { setLayersFilter } = useContext(MapContext);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        setLayersFilter(current => ({
            ...current,
            customHomePageRegions: regions,
            selectedCustomHomePageRegions: selectedTitles ?? regions.map(region => region.title)
        }));
    }, [enabled, regions, selectedTitles, setLayersFilter]);
};

export default useCustomHomePageLayers;
